import React from "react";
import { StorefrontManagementPage } from "@b2b/ui-components";
import { useAuth } from "../../auth/Authprovider";

export default function StorefrontManagement() {
  const { refetchUserStatus } = useAuth();
  return (
    <StorefrontManagementPage
      onStorefrontSaved={() => {
        refetchUserStatus();
      }}
    />
  );
}